import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { LanguageModule } from '@language';
import {
    ShActionGroupComponent,
    ShActionItemComponent,
    ShDialogComponent,
    ShDocumentViewerComponent,
    ShDragDataDirective,
    ShFacetComponent,
    ShFacetListComponent,
    ShFacetSummaryComponent,
    ShFixedHeaderPanelComponent,
    ShFormCheckboxWithDropdownModule,
    ShFormMultiSelectModule,
    ShHtmlParserComponent,
    ShIconLinkComponent,
    ShIconModule,
    ShImageViewerComponent,
    ShInlineDescriptionListComponent,
    ShMediaPlaceholderComponent,
    ShNotificationComponent,
    ShScrollspyNavComponent,
    ShToastModule,
    TranslateOrDefaultPipe
} from '@stylehaven/components';
import { ComplexValueTagComponent } from './complex-value-tag/complex-value-tag.component';
import { EmptyStubComponent } from './empty-stub-component/empty-stub.component';
import { FiltersComponent } from './filters/filters.component';
import { FragmentPreviewDialogComponent } from './fragment-preview-dialog/fragment-preview-dialog.component';
import { FragmentPreviewComponent } from './fragment-preview/fragment-preview.component';
import { KeyframesPreviewComponent } from './keyframes-preview/keyframes-preview.component';
import { MediaPlayerComponent } from './media-player/component/media-player.component';
import { PrivateWebsiteContainerComponent } from './private-website-container/private-website.container.component';
import { TagSuggestionsComponent } from './tag-suggestions/tag-suggestions.component';
import { UploadPanelComponent } from './upload-panel/upload-panel.component';

@NgModule({
    declarations: [
        TagSuggestionsComponent,
        FragmentPreviewComponent,
        FragmentPreviewDialogComponent,
        MediaPlayerComponent,
        UploadPanelComponent,
        EmptyStubComponent,
        FiltersComponent,
        PrivateWebsiteContainerComponent,
        ComplexValueTagComponent,
        KeyframesPreviewComponent
    ],
    imports: [
        ShActionGroupComponent,
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        ShActionItemComponent,
        ShFormMultiSelectModule,
        ShDialogComponent,
        ShIconModule,
        ShIconLinkComponent,
        ShInlineDescriptionListComponent,
        LanguageModule,
        ShImageViewerComponent,
        ShDocumentViewerComponent,
        ShFacetComponent,
        ShNotificationComponent,
        ShFacetListComponent,
        ShFacetSummaryComponent,
        ShFixedHeaderPanelComponent,
        ShDragDataDirective,
        ShMediaPlaceholderComponent,
        ShFormCheckboxWithDropdownModule,
        TranslateOrDefaultPipe,
        ShHtmlParserComponent,
        ShScrollspyNavComponent,
        ShToastModule
    ],
    exports: [
        TagSuggestionsComponent,
        FragmentPreviewComponent,
        FragmentPreviewDialogComponent,
        MediaPlayerComponent,
        UploadPanelComponent,
        EmptyStubComponent,
        FiltersComponent,
        PrivateWebsiteContainerComponent,
        ComplexValueTagComponent,
        KeyframesPreviewComponent
    ]
})
export class SharedElementsModule {}

export { ReadExportModeNotificationContainerComponent } from '../../page-header-notifications/containers/read-export-mode-notification/read-export-mode-notification.component';
export { ComplexValueTagComponent } from './complex-value-tag/complex-value-tag.component';
export { EmptyStubComponent } from './empty-stub-component/empty-stub.component';
export { FiltersComponent } from './filters/filters.component';
export { FragmentPreviewDialogComponent } from './fragment-preview-dialog/fragment-preview-dialog.component';
export { FragmentPreviewComponent } from './fragment-preview/fragment-preview.component';
export { KeyframesPreviewComponent } from './keyframes-preview/keyframes-preview.component';
export { MediaPlayerComponent } from './media-player/component/media-player.component';
export { PageNotFoundContainerComponent } from './page-not-found-container/page-not-found.container.component';
export { PrivateWebsiteContainerComponent } from './private-website-container/private-website.container.component';
export { TagSuggestionsComponent } from './tag-suggestions/tag-suggestions.component';
export { UploadPanelComponent } from './upload-panel/upload-panel.component';
export { ErrorPageTemplate } from './error-page/error-page.template';
export { ErrorPageContainerComponent } from './error-page/error-page.container.component';
export { ExpiredShareContainerComponent } from './error-page/expired-share.container.component';
export { ShareItemRemovedContainerComponent } from './error-page/share-item-removed.container.component';
